import ScrollContainer from "react-indiana-drag-scroll";
import { ButtonGroup, Button } from "@chakra-ui/react";

export default function ShowPixelPitch({ options, product, onProductChange }) {
    return (
        <ScrollContainer>
            <ButtonGroup spacing="20px">
                {options.map((opt) => {
                    const selected = product === opt.model;
                    return (
                        <Button
                            w="70px"
                            h="38.5px"
                            key={opt.id}
                            isDisabled={opt.disabled}
                            _hover={{
                                backgroundColor: opt.disabled
                                    ? undefined
                                    : selected
                                      ? "#FED141"
                                      : "#FFFFFF",
                            }}
                            _disabled={{
                                opacity: 1,
                                bg: "#ECECEC",
                                color: "#B2B2B2",
                                cursor: "not-allowed",
                            }}
                            borderColor={
                                opt.disabled
                                    ? "#D0D0D0"
                                    : selected
                                      ? "#E8D98F"
                                      : "#B2B2B2"
                            }
                            backgroundColor={
                                opt.disabled
                                    ? "#ECECEC"
                                    : selected
                                      ? "#FED141"
                                      : "#FFFFFF"
                            }
                            variant={selected && !opt.disabled ? "solid" : "outline"}
                            onClick={() => {
                                if (!opt.disabled) onProductChange(opt.model);
                            }}
                            fontSize="12px"
                            fontWeight="600"
                        >
                            {opt.label}
                        </Button>
                    );
                })}
            </ButtonGroup>
        </ScrollContainer>
    );
}
